import React from 'react';

import {CheckBox} from '@pb/kit-component-checkbox';
import {Cell, Head, Row} from '@pb/kit-component-table';

import {descriptionW, numberW, rulesW, selectW, usersW, vendorW} from '../constants';

type Props = {
    totalCount: number,
    allSelected: boolean,
    onSelectAll: () => void,
    onClearAll: () => void,
};

export const VendorManagementTableHeader: React.FC<Props> = ({
    totalCount,
    allSelected,
    onSelectAll,
    onClearAll,
}) => (
    <Head>
        <Row>
            <Cell width={numberW}>#</Cell>
            <Cell className="text-align_center" width={selectW}>
                <CheckBox
                    checked={allSelected ? totalCount > 0 : undefined}
                    onCheckBoxChange={({event}: {event: React.ChangeEvent<HTMLInputElement>}) =>
                        event.target.checked ? onSelectAll() : onClearAll()}
                    disabled={totalCount === 0}
                    usePropsOnly={true}
                />
            </Cell>
            <Cell width={vendorW}>Vendor Name</Cell>
            <Cell width={descriptionW}>Description</Cell>
            <Cell width={rulesW}>Rules</Cell>
            <Cell width={usersW}>Users</Cell>
        </Row>
    </Head>
);
